import { c as _c } from "react/compiler-runtime";
import { Box, Flex, Portal } from '@chakra-ui/react';
import React from 'react';
export type DiagnosticShellProps = {
  children: React.ReactNode;
  focused?: boolean;
  onDismiss?: () => void;
};

/**
 * Inline diagnostic card in the landing hero. When `focused`, the same card
 * portals into a modal so mid-page CTAs can reopen the claim flow.
 */
export const DiagnosticShell: React.FC<DiagnosticShellProps> = t0 => {
  const $ = _c(17);
  const {
    children,
    focused,
    onDismiss
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [4, 5];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <Box bg="colorPalette.container" borderColor="colorPalette.border/50" borderRadius="2xl" borderWidth="1px" boxShadow="md" maxWidth="lg" padding={t1} position="relative" textAlign="left" width="full">{children}</Box>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const card = t2;
  const t3 = focused ? "blur(10px)" : "blur(0px)";
  const t4 = focused ? 1 : 0;
  const t5 = focused ? "auto" : "none";
  const t6 = focused ? "blur(10px)" : "blur(0px)";
  let t7;
  if ($[3] !== t6) {
    t7 = {
      WebkitBackdropFilter: t6
    };
    $[3] = t6;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== onDismiss || $[6] !== t3 || $[7] !== t4 || $[8] !== t5 || $[9] !== t7) {
    t8 = <Portal><Box backdropFilter={t3} bg="colorPalette.bg/50" inset={0} opacity={t4} pointerEvents={t5} position="fixed" style={t7} transition="opacity 0.35s ease, backdrop-filter 0.35s ease" zIndex={40} onClick={onDismiss} /></Portal>;
    $[5] = onDismiss;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== card || $[12] !== focused) {
    t9 = focused ? <><Box aria-hidden={true} minHeight={["auto", "auto", "24rem"]} width="full" /><Portal><Flex align="center" inset={0} justify="center" overflowY="auto" padding={[3, 4, 6]} pointerEvents="none" position="fixed" width="full" zIndex={50}><Box maxWidth="lg" pointerEvents="auto" width="full">{card}</Box></Flex></Portal></> : <Flex justify="center" position="relative" width="full" zIndex={1}>{card}</Flex>;
    $[11] = card;
    $[12] = focused;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t8 || $[15] !== t9) {
    t10 = <>{t8}{t9}</>;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
};